import React from "react";

import HeaderView from "features/new/header/view";
import Main from "features/new/main";
import Footer from "features/new/footer/component";

import "screens/new/component/view.scss";

const HomeView = () => (
  <div className="home home-page">
    <HeaderView />
    <Main />
    <Footer />
  </div>
);

export default HomeView;
